import { render, staticRenderFns } from "./TestTabsScroll.vue?vue&type=template&id=d8932bca"
import script from "./TestTabsScroll.vue?vue&type=script&lang=js"
export * from "./TestTabsScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports